function ERC20Disclaimer() {
  return (
    <div className="text-white text-microLight">
      ERC20 tokens need to be approved and enabled before they can be
      transferred with the bridge as a standard security mechanism
    </div>
  );
}
export default ERC20Disclaimer;
